<template>
  <div>
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">Lote</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
        <div v-if="isDataLoaded" class="col-lg-6 col-5 text-right">
          <router-link
            v-if="(!plot.isShare && $can('update', 'plots')) || (plot.isShare && plot.write)"
            :to="{ name: 'PlotEdit', params: { id: plot.id } }"
            class="btn base-button btn-neutral btn-sm"
          >
            Editar
          </router-link>

          <router-link
            v-if="$can('index', 'rain_measures')"
            :to="{ name: 'PlotsRainsList' }"
            class="btn base-button btn-neutral btn-sm"
            >Ver precipitaciones
          </router-link>
          <!--  -->
        </div>
      </div>
    </base-header>

    <div v-if="isDataLoaded" class="container-fluid mt--6">
      <div class="row">
        <div class="col-md-12 col-sm-12">
          <plot-data :plot="plot" />
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 col-sm-12">
          <plot-trace v-if="isDataLoaded" :plot="plot" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import PlotData from './Show/PlotData';
import PlotTrace from './Show/PlotTrace';

export default {
  components: {
    RouteBreadCrumb,
    PlotData,
    PlotTrace,
  },

  data() {
    return {
      isDataLoaded: false,
      plot: null,
    };
  },

  mounted() {
    let plotId = this.$route.params.id;
    this.fetchPlot(plotId);
  },

  methods: {
    fetchPlot(id) {
      const params = {
        include: [
          'field.producer',
          'predecessor',
          'variety.crop',
          'campaign',
          'preEmergence.pictures',
          'preEmergence.productionDestination',
          'emergence.pictures',
          'harvest.pictures',
          'preEmergence.comments',
          'emergence.comments',
          'harvest.comments',
          'plotType',
          'coordinates',
        ],

        append: ['rainMeasuresTotal'],
      };

      this.$services
        .resource('plots')
        .show(id, params)
        .then((res) => res.data.data)
        .then((plot) => {
          this.plot = plot;
          this.isDataLoaded = true;
        });
    },
  },
};
</script>
